import './App.css';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ContentBlockComponent from './ContentBlock';
import { ContentBlock } from './types';
import { loadPostById, BlogPost as BlogPostType } from './data/postsLoader';

function BlogPost(): React.JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [blogPost, setBlogPost] = useState<BlogPostType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (id) {
      loadPostById(Number(id))
        .then(post => {
          setBlogPost(post);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error loading blog post:', error);
          setLoading(false);
        });
    }
  }, [id]);

  if (loading) {
    return (
      <div className="App blog-page-static">
        <section className="blog-page blog-page-detail">
          <article className="blog-post-detail">
            <p style={{ color: '#ffffff' }}>Loading...</p>
          </article>
        </section>
      </div>
    );
  }

  if (!blogPost) {
    return (
      <div className="App blog-page-static">
        <section className="blog-page blog-page-detail">
          <article className="blog-post-detail">
            <p style={{ color: '#ffffff' }}>Post not found.</p>
          </article>
        </section>
      </div>
    );
  }

  return (
    <div className="App blog-page-static">
      <section className="blog-page blog-page-detail">
        <article className="blog-post-detail">
          <div className="blog-post-detail-header">
            <div className="blog-post-detail-heading">
              <h1 className="blog-post-detail-title">{blogPost.title}</h1>
              <span className="blog-post-detail-divider" aria-hidden="true">|</span>
              <span className="blog-category">{blogPost.category}</span>
            </div>
            <span className="blog-date">{blogPost.date}</span>
          </div>
          <div className="blog-post-detail-content">
            {blogPost.content.map((block, index) => (
              <ContentBlockComponent key={index} block={block as ContentBlock} />
            ))}
          </div>
        </article>
      </section>
    </div>
  );
}

export default BlogPost;

